// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";
import { IAsyncAction } from 'common/api/types';

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { createAPINetworkInstance } from '../../../../common/api';

// Types
import { ActionGetWidgetsConfig, ActionGetWidgetsPublish, ActionGetWidgetsHtmlCalls, ActionSaveWidgetsConfig, ActionSaveWidgetsPublish, getWidgetsConfigSuccess, getWidgetsPublishSuccess, getWidgetsHtmlCallsError, getWidgetsConfigError, getWidgetsPublishError, saveWidgetsConfigSuccess, saveWidgetsConfigError, saveWidgetsPublishError, getOverallRatingSuccess,
    ActionGetProvidersRating, getProvidersRatingSuccess, getProvidersRatingError, ActionGetOverallRating, getWidgetsHtmlCallsSuccess, ActionGetReviews, getReviewsSuccess, getReviewsConfigSuccess, ActionGetReviewsFiltered,
    getReviewsFilteresSuccess } from './actions';
import { OverallRatingResponse, Widgets, ProvidersRatingResponse, WidgetsCalls, Review, ReviewsConfig, ReviewsFiltered } from './types';

function* getGetWidgetsConfig(action: ActionGetWidgetsConfig) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/widgetsConfig/${action.iddealer}`);
        yield put(getWidgetsConfigSuccess(data as Widgets));
    } catch (err) {
        yield put(getWidgetsConfigError(err));
    }
}

function* getGetWidgetsPublish(action: ActionGetWidgetsPublish) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/widgetsPublish/${action.iddealer}`);
        yield put(getWidgetsPublishSuccess(data as Widgets));
    } catch (err) {
        yield put(getWidgetsPublishError(err));
    }
}

function* getReviews(action: ActionGetReviews) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/reviews${action.filter}`);
        yield put(getReviewsSuccess(data as Review[]));
        if (action.callback) action.callback(data);
    } catch (err) {
        yield put(getWidgetsConfigError(err));
        if (action.callback) action.callback(undefined, err);
    }
}

function* getReviewsConfig(action: IAsyncAction) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/utils/reviews_config`);
        yield put(getReviewsConfigSuccess(data as ReviewsConfig));
        if (action.callback) action.callback(data);
    } catch (err) {
        if (action.callback) action.callback(undefined, err);
    }
}

function* getGetWidgetsCalls(action:  ActionGetWidgetsHtmlCalls) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/WebSiteWidgetsCalls/${action.iddealer}`);
        yield put(getWidgetsHtmlCallsSuccess(data as WidgetsCalls));
    } catch (err) {
        yield put(getWidgetsHtmlCallsError(err));
    }
}

function* getOverallRating(action: ActionGetOverallRating) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/overallRating/${action.iddealer}/${action.widgetPageType}`);
        yield put(getOverallRatingSuccess(data as OverallRatingResponse));
    } catch (err) {
        yield put(getWidgetsConfigError(err));
    }
}

function* saveGetWidgetsConfig(action: ActionSaveWidgetsConfig) {
    try {
        const { data } = yield call(createAPINetworkInstance().post, `widgetsConfig`, action.widgets);        
        yield put(getWidgetsConfigSuccess(data as Widgets));
        if (action.callback) action.callback(data);
    } catch (err) {
        yield put(saveWidgetsConfigError(err));
        if (action.callback) action.callback(undefined, err);
    }
}

function* publishWidgetsConfig(action: ActionSaveWidgetsPublish) {
    try {
        const { data } = yield call(createAPINetworkInstance().post, `widgetsPublish`, {widgetsConfig: action.widgetsPublish, typeConfig: action.selectedTab}, );        
        yield put(getWidgetsPublishSuccess(data as Widgets));
        if (action.callback) action.callback(data);
    } catch (err) {
        yield put(saveWidgetsPublishError(err));
        if (action.callback) action.callback(undefined, err);
    }
}

function* getProvidersRating(action: ActionGetProvidersRating) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/providersRating/${action.iddealer}`);
        yield put(getProvidersRatingSuccess(data as ProvidersRatingResponse));
    } catch (err) {
        yield put(getProvidersRatingError(err));
    }
}

function* getReviewsFiltered(action: ActionGetReviewsFiltered) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/reviews/${action.idDealer}?${action.query}`);
        yield put(getReviewsFilteresSuccess(data as ReviewsFiltered));
        if (action.callback) action.callback(data);
    } catch (err) {
        yield put(getWidgetsConfigError(err));
        if (action.callback) action.callback(undefined, err);
    }
}

export default function* clientSagas() {
    yield takeLatest(ACTIONS.GET_WIDGETS_CONFIG, getGetWidgetsConfig);
    yield takeLatest(ACTIONS.GET_WIDGETS_PUBLISH, getGetWidgetsPublish);
    yield takeLatest(ACTIONS.GET_REVIEWS, getReviews);
    yield takeLatest(ACTIONS.GET_REVIEWS_FILTERED, getReviewsFiltered);
    yield takeLatest(ACTIONS.GET_REVIEWS_CONFIG, getReviewsConfig);
    yield takeLatest(ACTIONS.GET_WIDGETS_HTML_CALLS, getGetWidgetsCalls);
    yield takeLatest(ACTIONS.GET_OVERALL_RATING, getOverallRating);
    yield takeLatest(ACTIONS.SAVE_WIDGETS_CONFIG, saveGetWidgetsConfig);
    yield takeLatest(ACTIONS.SAVE_WIDGETS_PUBLISH, publishWidgetsConfig);
    yield takeLatest(ACTIONS.GET_PROVIDERS_RATING, getProvidersRating);
}
